import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ProductComponentDef } from '@df/catalog-ui/product/product.component.def';
import { IProductDataV2, Product } from '@df/catalog/product/product';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { optionLabelPipe } from '@df/ui/common/option-label.pipe';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ReviewsIORatingComponent } from '../../../module/reviews-io/components/reviews-io-rating.component';
import { NCmsHotspots } from '../cms-hotspots.interface';

@Component({
    selector: 'cms-hotspots-product',
    templateUrl: './hotspots-product.component.html',
    styleUrl: '../wrapper/hotspots-wrapper.component.scss',
    standalone: true,
    imports: [TranslationModule, DfImageDirective, PriceComponent, ReviewsIORatingComponent, HrefComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsHotspotsProductComponent extends ProductComponentDef<Product<IProductDataV2>> {
    hotspot = input.required<NCmsHotspots.IHotspot>();
    close = output<void>();

    get rangeDescription(): string | undefined {
        return optionLabelPipe(this.model.data?.nyw_item_range_desc_nh_bs, 'nyw_item_range_desc_nh_bs') as string | undefined;
    }

    closeOverlay(): void {
        this.close.emit();
    }
}
